import React, { memo, useEffect, useState } from 'react';
import { useAction } from '../../Api/newSockets.api';
import Repeatable from 'react-repeatable';


type Props = {
    deviceId: string,
    authSocket: any,
}

const JoystickConveyor = memo((props: Props) => {

    const { getAction, connected, runAction } = useAction();

    const [speed, setSpeed] = useState("10");
    const [action, setAction] = useState({ id: 0, inputs: [] });


    useEffect(() => {
        getAction(55).then((data: any) => {
            setAction(data);
        });
    }, [connected]);

    console.log("Action ", action)

    const RepeatableButton = ({ onHoldStart, onHoldEnd, tag, ...props }) => (
        <Repeatable
            tag={tag}
            type={tag}
            onHoldStart={onHoldStart}
            onHoldEnd={onHoldEnd}
            repeatDelay={0}
            repeatInterval={150}
            {...props}
        />
    );

    const onSpeedChange = (e) => {
        setSpeed(e.target.value);
    }

    const run = (positiveDirection) => {
        const newInputs = action?.inputs.map((input: any) => Object.assign({ ...input, value: positiveDirection ? speed : "-" + speed }));
        runAction({ id: action.id, inputs: newInputs }, parseInt(props.deviceId));
    }

    const stop = () => {
        const newInputs = action?.inputs.map((input: any) => Object.assign({ ...input, value: "0" }));
        runAction({ id: action.id, inputs: newInputs }, parseInt(props.deviceId));
    }

    return (
        <div className="joystick-container">
            <div className="radio-form">
                <p className="form-title">Speed</p>
                <div className="radio-container" >
                    <label>
                        <input type="radio" value="10" onChange={onSpeedChange} checked={speed == "10"} name="distance" />
                        10
                    </label>
                    <label>
                        <input type="radio" value="20" onChange={onSpeedChange} checked={speed == "20"} name="distance" />
                        20
                    </label>
                    <label>
                        <input type="radio" value="40" onChange={onSpeedChange} checked={speed == "40"} name="distance" />
                        40
                    </label>
                    <label>
                        <input type="radio" value="60" onChange={onSpeedChange} checked={speed == "60"} name="distance" />
                        60
                    </label>
                    <label>
                        <input type="radio" value="100" onChange={onSpeedChange} checked={speed == "100"} name="distance" />
                        100
                    </label>
                </div>
            </div>
            <div className="joystick">
                <svg viewBox="113.191 80.598 724.849 340" xmlns="http://www.w3.org/2000/svg" >

                    <RepeatableButton tag="path" onHoldStart={e => run(true)} onHoldEnd={e => stop()} d="M 539.184 120.287 L 583.091 201.17 L 495.276 201.17 L 539.184 120.287 Z" className="triangle_controls" />
                    <RepeatableButton tag="path" onHoldStart={e => run(false)} onHoldEnd={e => stop()} d="M -539.02 -380.537 L -495.113 -299.654 L -582.928 -299.654 L -539.02 -380.537 Z" className="triangle_controls" transform="matrix(-1, 0, 0, -1, 0, 0)" />
                    <text className="text" x="532.526" y="220.61">Z+</text>
                    <text className="text" x="534.702" y="290.678">Z-</text>
                    <RepeatableButton tag="rect" onHoldStart={e => run(false)} onHoldEnd={e => stop()} x="217.537" y="254.143" width="5.546" height="24.244" className="signs" transform="matrix(0, 1, -1, 0, 805.140747, 99.919144)" />
                    <RepeatableButton tag="path" onHoldStart={e => run(true)} onHoldEnd={e => stop()} d="M 549.409 174.769 L 549.409 179.635 L 541.206 179.635 L 541.206 187.838 L 536.34 187.838 L 536.34 179.635 L 528.137 179.635 L 528.137 174.769 L 536.34 174.769 L 536.34 166.566 L 541.206 166.566 L 541.206 174.769 L 549.409 174.769 Z" className="signs" />

                </svg>
                <div className="slider-container">
                    <p className="label">Max speed</p>
                    <input className="speed-control" type="range" min="0" max="10" step="1" />
                    <p className="label">Min speed</p>
                </div>
            </div>

        </div>
    )
});

export default JoystickConveyor;